/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RightBuccalNoRetractors1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import RightBuccalNoRetractors from 'DesignSystem/Images/RightBuccalNoRetractors/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function RightBuccalNoRetractors1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Instructions/Illustrations/Illustration/RightBuccalNoRetractors"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<RightBuccalNoRetractors
  viewPath={`${viewPath}/RightBuccalNoRetractors`}
 width="100%"
 height="100%"
 objectFit="contain"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceM}
 marginLeft="auto"
 marginRight="auto"
/>
{children}
</React.Fragment>)
}